app.service('loginMyAccount', function () {
	var $self, $form, $login, $password, $email;

	function newErpOrdersLoginMessage(login) {
		$.ajax({
			url: '/erp-orders-login-message.ltr',
			dataType: 'json',
			async: false,
			data: {
				login: login
			},
			success: function (json) {
				$('#erp-orders-login-message').html(json.message);
				$self.addClass('show-erp-login-message');
			}
		});
	}
	function newErpOrdersRegistrationMessage(login) {
		$.ajax({
			url: '/erp-orders-registration-message.ltr.ltr',
			dataType: 'json',
			async: false,
			data: {
				login: login
			},
			success: function (json) {
				$('#erp-orders-registration-message').html(json.message);
				$self.addClass('show-erp-registration-message');
			}
		});
	}
	function send() {
		var login = $login.val();
		var loginValid = $login.valid();
		var $captcha = $('#login-captcha #g-recaptcha-response');
		var captchaValid = $captcha.length ? $captcha.valid() : true;

		if (loginValid && captchaValid) {
			$.ajax({
				url: '/front-user-account-exist.ltr',
				dataType: 'json',
				async: false,
				data: {
					email: login
				},
				success: function (json) {
					$self.removeClass('show-login-box');
					if (json.exists) {
						newErpOrdersLoginMessage(login);
						$self.addClass('show-password-box');
						$password.focus();
					} else {
						$email.val(login);
						newErpOrdersRegistrationMessage(login);
						$self.addClass('registration-view');
					}
				},
				error: function () {
					modal.alert('Błąd wysyłania formularza. Proszę spróbować później');
				}
			});
		}
	}
	function setElements() {
		$self = $('#moje-konto');
		$form = $('#container form:eq(0)', $self);
		$login = $('#login-username', $form);
		$password = $('#login-password', $form);
		$email = $('#email', $form);
	}
	function setEvents() {
		$('.js-my-account-login-button', $form).on('click', function () {
			send();
		});
	}
	function init() {
		setElements();
		setEvents();
	}
	return {
		init: init
	};
});
